import { MathJax, MathJaxContext } from "better-react-mathjax";
import { IConfig } from "./Render";
export const Latex = ({ className, id, children, style }: IConfig) => {
  const config = {
    loader: { load: ["[tex]/html", "[tex]/enclose", "[tex]/color", "[tex]/cancel" ] },
    tex: {
      packages: { "[+]": ["html", "enclose", "color", "cancel"] },
      inlineMath: [
        ["$", "$"],
        ["\\(", "\\)"]
      ],
      displayMath: [
        ["$$", "$$"],
        ["\\[", "\\]"]
      ]
    },
    startup: {
      typeset: false
    }
  };
  return (

    <MathJaxContext config={config}>
      <MathJax style={style}>{children}</MathJax>
    </MathJaxContext>
  );
}